/** 定義路由名稱與路徑
 * url: 顯示在URL上
 * label: 顯示在網頁上
 * */

const pathConfig = {
  root: {
    url: "/",
    label: "首頁",
  },
  edit: {
    url: "/Edit",
    label: "編輯",
  },
  search: {
    url: "/Search",
    label: "搜尋",
  },
  download: {
    url: "/Download",
    label: "下載",
  },
  auth: {
    url: "/Authority",
    label: "權限",
  },
  signIn: {
    url: "/SignIn",
    label: "登入",
  },
  signOut: {
    url: "/SignOut",
    label: "登出",
  },
  importData: {
    url: "/ImportData",
    label: "匯入資料",
  },
  history: {
    url: "/History",
    label: "歷史資訊",
  },
  statistics: {
    url: "/Statistics",
    label: "統計資訊",
  },
};

export default pathConfig;
